import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { userContext } from '../../context/ContextProvider';
import './Login.css';
import axiosInstance from '../../services/axiosConfig';
import { ShieldCheck, ShieldAlert, MailCheck } from 'lucide-react';
import packageJson from '../../../package.json';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setUser, setRole, setAuthenticated } = useContext(userContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axiosInstance.post('/auth/login', {
        email,
        password,
      });

      const data = response.data;

      if (!data || !data.accessToken) {
        throw new Error('Invalid response from server');
      }

      const user = data.data || data.user;
      if (!user) {
        throw new Error('No user data in response');
      }

      // ✅ Calculate token expiry (backend says 24 hours)
      const expiresIn = data.expiresIn || 86400000; // 24 hours in milliseconds
      const expiryTime = Date.now() + expiresIn;

      // ✅ Store token and expiry
      sessionStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('accessToken', data.accessToken); // Backup
      localStorage.setItem('tokenExpiry', expiryTime.toString());
      localStorage.setItem('user', JSON.stringify(user));

      // Update context
      setUser(user);
      setRole(user.role.toLowerCase());
      setAuthenticated(true);

      console.log('✅ Login successful:', {
        email: user.email,
        tokenExpiresIn: '24 hours',
        expiryTime: new Date(expiryTime).toLocaleString()
      });

      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.message || err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="desktop-container">
        {/* <!-- Left Panel: Branding and Professional Information --> */}
        <div className="left-panel">
          <div className="brand-container">
            <div className="logo-container">
              <div className="system-name">Theresa Products</div>
              <div className="system-tagline">Sales Management System</div>
            </div>
          </div>

          <div className="version-info">
            By FIDES Management | V.{packageJson.version}
          </div>
        </div>

        <div className="right-panel">
          <div className="login-card">
            <div className="card-header">
              <h2 className="admin-title">Admin Login</h2>
              <p className="admin-subtitle">Access your admin dashboard</p>
            </div>

            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                <p>{error}</p>
              </div>
            )}

            <div className="card-body">
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="example@gmail.com"
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  disabled={loading}
                />
              </div>

              <div className="login-forgot-container">
                <button
                  type="button"
                  onClick={() => {}}
                  className="login-forgot-btn"
                >
                  Forgot Password?
                </button>
              </div>

              <button
                onClick={handleLogin}
                disabled={loading}
                className="login-submit-btn"
              >
                {loading ? 'Logging in...' : 'Log In'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}